require('./registration.style.scss');

const registrationModule = angular.module('com.comtrade.azureCloud.backup.registrationModule', []);

registrationModule.component('registration', require('./registration.component'));

registrationModule.service('registrationService', require('./registration.persistence.service'));

module.exports = registrationModule;


// WEBPACK FOOTER //
// ./src/azurebackup/views/registration/registration.module.js